import { router } from 'expo-router';
import * as WebBrowser from 'expo-web-browser';
import { useState } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { Divider } from 'react-native-paper';

import { NonProfitOrgProfileResponse } from '@/api/models/nonProfitOrgModels';
import BrandedButton from '@/components/buttons/BrandedButton';
import EditButton from '@/components/buttons/EditButton';
import Text from '@/components/Text';
import { useEndFlowModal } from '@/contexts/endFlowModalContext';
import { useColor } from '@/hooks/useColor';
import { firebaseImage, safeJsonParseArray } from '@/utils/firebaseImage';
import { i18n } from '@/utils/i18n';

const AuditItem = ({
  canEdit,
  thirdPartyAudit,
  thirdPartyAuditDeny,
  npoId
}: {
  canEdit: boolean;
  thirdPartyAudit: NonProfitOrgProfileResponse['thirdPartyAudit'];
  thirdPartyAuditDeny: NonProfitOrgProfileResponse['thirdPartyAuditDeny'];
  npoId: NonProfitOrgProfileResponse['id'];
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { showError } = useEndFlowModal();

  const thirdPartyAuditFile = safeJsonParseArray(thirdPartyAudit ?? '');

  const onPress = async () => {
    if (thirdPartyAudit && thirdPartyAuditFile.length > 0) {
      setIsLoading(true);
      try {
        let url = firebaseImage(safeJsonParseArray(thirdPartyAudit)?.at(0));
        await WebBrowser.openBrowserAsync(url);
      } catch {
        showError({});
      }
      setIsLoading(false);
    }
  };
  const colors = useColor();
  return (
    <View>
      <View style={styles.titleContainer}>
        <View style={styles.titleContent}>
          <Text style={[styles.titleText, { color: colors.titleText }]} fontWeight="700">
            {i18n.t('npo_details.insights.thirdPartyAudit')}
          </Text>
        </View>
        {canEdit && (
          <EditButton
            onPress={() => {
              const params: Record<string, string | null> = {
                thirdPartyAudit,
                npoId
              };

              if (thirdPartyAuditDeny !== null) {
                params.thirdPartyAuditDeny = thirdPartyAuditDeny ? 'true' : 'false';
              }

              router.navigate({
                pathname: '/edit/npoPartyAudit',
                params
              });
            }}
          />
        )}
      </View>
      <View style={styles.content}>
        {thirdPartyAudit && thirdPartyAuditFile.length > 0 ? (
          <BrandedButton style={styles.button} onPress={onPress} loading={isLoading}>
            {i18n.t('npo_details.insights.thirdPartyAudit_button')}
          </BrandedButton>
        ) : (
          <Text> {i18n.t('mix.n_a')}</Text>
        )}
      </View>
      <Divider />
    </View>
  );
};

export default AuditItem;

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  titleContent: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center'
  },

  titleText: {
    fontSize: 22,
    marginRight: 10
  },

  content: {
    marginTop: 10,
    marginBottom: 20
  },

  button: {
    borderRadius: 20,
    width: Platform.OS !== 'web' ? '50%' : '100%',
    height: 34
  }
});
